export const CloseIcon = () => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6875 2.21875L7.40625 5.5L10.6875 8.8125C11.0938 9.1875 11.0938 9.84375 10.6875 10.2188C10.3125 10.625 9.65625 10.625 9.28125 10.2188L6 6.9375L2.6875 10.2188C2.3125 10.625 1.65625 10.625 1.28125 10.2188C0.875 9.84375 0.875 9.1875 1.28125 8.8125L4.5625 5.5L1.28125 2.21875C0.875 1.84375 0.875 1.1875 1.28125 0.8125C1.65625 0.40625 2.3125 0.40625 2.6875 0.8125L6 4.09375L9.28125 0.8125C9.65625 0.40625 10.3125 0.40625 10.6875 0.8125C11.0938 1.1875 11.0938 1.84375 10.6875 2.21875Z"
      fill="#353535"
    />
  </svg>
);
